import { CheckSolidV6 } from "@shared/v2/Icomoon";
import { Product } from "../../../../Support/Account/AddOnsSupport/types";

const Step2Up: React.FC<{ newProduct?: Product }> = ({ newProduct }) => (
  <div className="tw-flex tw-flex-col tw-gap-[8px]">
    <div className="tw-flex tw-items-center tw-gap-[8px]">
      <CheckSolidV6 className="tw-text-semantic-green-120" size="l" />
      <b>{newProduct?.details.trackingNumberMax}</b> tracking numbers total
    </div>
    <div className="tw-flex tw-items-center tw-gap-[8px]">
      <CheckSolidV6 className="tw-text-semantic-green-120" size="l" />
      <b>{newProduct?.details.minutesPerMonth.toLocaleString()}</b> included minutes
    </div>
    <div className="tw-flex tw-items-center tw-gap-[8px]">
      <CheckSolidV6 className="tw-text-semantic-green-120" size="l" />
      <b>+{newProduct?.details.overageMinutesPrice * 100} cents</b> per minute over{" "}
      {newProduct?.details.minutesPerMonth.toLocaleString()}
    </div>
  </div>
);

export default Step2Up;
